// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"46":"8955789b","152":"8b0942d0","199":"0bc2deb1","254":"10bc864a","418":"0129c2ed","519":"3114d726","629":"6eea14d7","666":"b0ddc4bf","977":"3e255ff8"}[chunkId] + ".js";
};